import { render, staticRenderFns } from "./CreatorLivestreamAgora.vue?vue&type=template&id=ecf77034&scoped=true&"
import script from "./CreatorLivestreamAgora.vue?vue&type=script&lang=js&"
export * from "./CreatorLivestreamAgora.vue?vue&type=script&lang=js&"
import style0 from "./CreatorLivestreamAgora.vue?vue&type=style&index=0&id=ecf77034&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf77034",
  null
  
)

export default component.exports